<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="520px" center :close-on-click-modal="false">
    <div class="content">
      <div>以下商品组套数量大于500，请确认是否有折扣价并进行修改</div>
      <div v-for="item in rows" :key="item.key" class="row">
        No：{{ item.no }}&nbsp;&nbsp;&nbsp;&nbsp;组套数量 {{ item.quantity }}
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'LargeSetQuantityPrompt',
  data() {
    return {
      dialogVisible: false,
      rows: []
    }
  },
  methods: {
    open(list) {
      this.rows = []
      if (!Array.isArray(list)) return

      // 找出每个商品中“配套”数量超过 500 的记录。
      list.forEach((item, index) => {
        const options = Array.isArray(item.option) ? item.option : []
        const option = options.find(optionItem => String(optionItem.name || '').trim() === '配套')
        if (option && Number(option.num) > 500) {
          this.rows.push({
            key: `${item.sorting || index}-${index}`,
            no: item.sorting || '-',
            quantity: option.num,
            sort: Number(item.sorting) || index
          })
        }
      })

      // 按商品 No 从小到大展示。
      this.rows.sort((a, b) => a.sort - b.sort)
      this.dialogVisible = this.rows.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.content { line-height: 28px; }
.row { white-space: pre; }
</style>
